// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "productpg/" + ({"189":"page-mixAndMatch","404":"page-singleProduct","406":"deferred"}[chunkId] || chunkId) + "." + {"162":"4ce98b80bdb5d1b8edad","189":"d586b7868d2e5b7f1262","404":"5f1fd05014cfda88bc4a","406":"dcb78d35f5caf9875cac"}[chunkId] + ".css";
};